import { cn } from "cn";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      className={cn(
        "border-gray-400 bg-gray-100 transition-[border-color,box-shadow] duration-150 ease-out placeholder:text-fg-muted hover:border-gray-700",
        "min-h-55 w-full rounded-lg border p-3 text-fg",
        "focus-visible:border-gray-700 focus-visible:shadow-focus focus-visible:outline-none",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      data-slot="textarea"
      {...props}
    />
  );
}

export { Textarea };
